export const APP_INITIATED = 'APP_INITIATED';
export const APP_INITIATION_FAILED = 'APP_INITIATION_FAILED';
export const APP_DISCONNECTED = 'APP_DISCONNECTED';
export const APP_MODE_CHANGED = 'APP_MODE_CHANGED';
export const APP_ERROR = 'APP_ERROR';

// notifications
export const CLEAR_NOTIFICATION_REQUESTED = 'CLEAR_NOTIFICATION_REQUESTED';

// workflow
export const IMAGE_WORKFLOW_STARTED = 'IMAGE_WORKFLOW_STARTED';
export const IMAGE_WORKFLOW_FINISHED = 'IMAGE_WORKFLOW_FINISHED';
export const IMAGE_WORKFLOW_ABANDONED = 'IMAGE_WORKFLOW_ABANDONED';
export const CLONE_WORKFLOW_STARTED = 'CLONE_WORKFLOW_STARTED';
export const CLONE_WORKFLOW_FINISHED = 'CLONE_WORKFLOW_FINISHED';
export const CLONE_WORKFLOW_ABANDONED = 'CLONE_WORKFLOW_ABANDONED';

// Update store
export const BACKUP_LOCATION_ADDITION_UPDATED = 'BACKUP_LOCATION_ADDITION_UPDATED';
export const SQL_SERVER_INSTANCE_ADDITION_UPDATED = 'SQL_SERVER_INSTANCE_ADDITION_UPDATED';
export const IMAGE_DESTINATION_LOCATION_ADDITION_UPDATED = 'IMAGE_DESTINATION_LOCATION_ADDITION_UPDATED';

// Image creation
export const IMAGE_CREATION_UPDATED = 'IMAGE_CREATION_UPDATED';
export const OPERATION_PROGRESS_UPDATED = 'OPERATION_PROGRESS_UPDATED';

// Clone creation
export const CLONE_CREATION_UPDATED = 'CLONE_CREATION_UPDATED';

// Imaging creation form flow
export const IMAGE_SOURCE_SELECTED = 'IMAGE_SOURCE_SELECTED';
export const IMAGE_SOURCE_LOCATION_SELECTED = 'IMAGE_SOURCE_LOCATION_SELECTED';
export const IMAGE_DESTINATION_SELECTED = 'IMAGE_DESTINATION_SELECTED';
export const IMAGE_CREATION_CONFIRMED = 'IMAGE_CREATION_CONFIRMED';
export const IMAGE_NAME_SELECTED = 'IMAGE_NAME_SELECTED';

// Clone creation form flow
export const CLONE_SOURCE_SELECTED = 'CLONE_SOURCE_SELECTED';
export const CLONE_DESTINATION_SELECTED = 'CLONE_DESTINATION_SELECTED';

// Fetch data from stores
export const BACKUP_LOCATIONS_UPDATED = 'BACKUP_LOCATIONS_UPDATED';
export const SQL_SERVER_INSTANCES_UPDATED = 'SQL_SERVER_INSTANCES_UPDATED';
export const IMAGE_DESTINATION_LOCATIONS_UPDATED = 'IMAGE_DESTINATION_LOCATIONS_UPDATED';
export const DATABASES_ON_INSTANCE_UPDATED = 'DATABASES_ON_INSTANCE_UPDATED';
export const IMAGES_UPDATED = 'IMAGES_UPDATED';
export const CLONES_UPDATED = 'CLONES_UPDATED';
export const AGENTS_UPDATED = 'AGENTS_UPDATED';

// Management mode actions
export const CLONE_DELETION_UPDATED = 'CLONE_DELETION_UPDATED';
export const IMAGE_DELETION_UPDATED = 'IMAGE_DELETION_UPDATED';
// Notifications from externallyTriggeredActionCreator 
// Note: strings must be uppercased equivalent of C# enum ClientMessageType
export const OPERATION_STATUS_UPDATED = 'OPERATION_STATUS_UPDATED';
export const OPERATION_MESSAGE = 'OPERATION_MESSAGE';
export const IMAGE_STATUS_UPDATED = 'IMAGE_STATUS_UPDATED';
export const CLONE_STATUS_UPDATED = 'CLONE_STATUS_UPDATED';
export const INSTANCE_DETAILS_UPDATED = 'INSTANCE_DETAILS_UPDATED';
export const AGENT_STATUS_CHANGED = 'AGENT_STATUS_CHANGED';
export const APP_UPDATE_AVAILABLE = 'APP_UPDATE_AVAILABLE';
export const APP_LICENCE_UPDATED = 'APP_LICENCE_UPDATED';

export const SQL_SERVER_INSTANCE_STATUS_REQUESTED = 'SQL_SERVER_INSTANCE_STATUS_REQUESTED';
export const SQL_SERVER_INSTANCE_STATUS_COMPLETED = 'SQL_SERVER_INSTANCE_STATUS_COMPLETED';
export const IMAGE_LOCATION_VALIDATION_REQUESTED = 'IMAGE_LOCATION_VALIDATION_REQUESTED';
export const IMAGE_LOCATION_VALIDATION_COMPLETED = 'IMAGE_LOCATION_VALIDATION_COMPLETED';
export const BACKUP_LOCATION_VALIDATION_REQUESTED = 'BACKUP_LOCATION_VALIDATION_REQUESTED';
export const BACKUP_LOCATION_VALIDATION_COMPLETED = 'BACKUP_LOCATION_VALIDATION_COMPLETED';

export const CURRENT_USER_UPDATED = 'CURRENT_USER_UPDATED';


export const TOUR_ENABLED_CHANGED = 'TOUR_ENABLED_CHANGED';

export const PERMISSIONS_UPDATED = 'PERMISSIONS_UPDATED';
export const PERMISSIONS_CHANGE_UPDATED = 'PERMISSIONS_CHANGE_UPDATED';

export const GETTING_STARTED_ENABLED_CHANGE_REQUESTED = 'GETTING_STARTED_ENABLED_CHANGE_REQUESTED';




// WEBPACK FOOTER //
// ./src/js/actions/actionTypes.js